// mui
import { Box, Button, Typography } from '@mui/material';

// components
import { goToLogin } from '..';

const TEXTS = {
    home: ['Recommended for you', 'Log in to see posts picked for what you like.'],
    messages: ['Start a conversation', 'Log in to send and receive messages.'],
    profile: ['Create your profile', 'Log in to set up your own profile.'],
    settings: ['Manage your account', 'Log in to change your settings.'],
};
TEXTS.conversation = TEXTS.messages;

// Body of a login-only tab (Recommend, Messages, Profile, Settings) for a guest. The tab bar stays,
// so the guest can keep browsing other tabs; the button opens the login page and returns here after.
function LoginRequiredBody({ path }) {
    const [title, description] = TEXTS[path] ?? TEXTS.home;
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                px: 2,
            }}>
            <Typography align='center' variant='h6' color='primary.main'>
                {title}
            </Typography>
            <Typography align='center' variant='body2' color='text.secondary'>
                {description}
            </Typography>
            <Button variant='contained' aria-label='go to login' onClick={() => goToLogin()} sx={{ mt: 1 }}>
                Log in
            </Button>
        </Box>
    );
}

export { LoginRequiredBody };
